export function SpecialistProfileSkeleton() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="border-b border-border bg-card">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="h-10 w-48 bg-muted animate-pulse rounded-md" />
            <div className="h-10 w-24 bg-muted animate-pulse rounded-md lg:hidden" />
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
          {/* Left Column */}
          <div className="lg:col-span-3 space-y-8">
            {/* Profile Card Skeleton */}
            <div className="bg-card rounded-lg border shadow-sm p-8">
              <div className="flex flex-col md:flex-row gap-6">
                <div className="w-32 h-32 bg-muted animate-pulse rounded-lg" />
                <div className="flex-1 space-y-4">
                  <div className="h-8 w-64 bg-muted animate-pulse rounded" />
                  <div className="flex gap-2">
                    <div className="h-6 w-24 bg-muted animate-pulse rounded-full" />
                    <div className="h-6 w-24 bg-muted animate-pulse rounded-full" />
                  </div>
                  <div className="h-6 w-20 bg-muted animate-pulse rounded" />
                  <div className="h-4 w-full bg-muted animate-pulse rounded" />
                </div>
              </div>
            </div>

            {/* About Section Skeleton */}
            <div className="bg-card rounded-lg border shadow-sm p-6 space-y-4">
              <div className="h-6 w-48 bg-muted animate-pulse rounded" />
              <div className="space-y-2">
                <div className="h-4 w-full bg-muted animate-pulse rounded" />
                <div className="h-4 w-full bg-muted animate-pulse rounded" />
                <div className="h-4 w-3/4 bg-muted animate-pulse rounded" />
              </div>
            </div>

            {/* Credentials Grid Skeleton */}
            <div className="grid gap-6">
              {[1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  className="bg-card rounded-lg border shadow-sm p-6"
                >
                  <div className="h-6 w-48 bg-muted animate-pulse rounded mb-4" />
                  <div className="space-y-2">
                    <div className="h-4 w-full bg-muted animate-pulse rounded" />
                    <div className="h-4 w-5/6 bg-muted animate-pulse rounded" />
                    <div className="h-4 w-4/6 bg-muted animate-pulse rounded" />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Calendar Skeleton */}
          <div className="lg:col-span-2">
            <div className="lg:sticky lg:top-8">
              <div className="bg-card rounded-lg border shadow-sm p-6 space-y-6">
                <div className="h-6 w-48 bg-muted animate-pulse rounded" />
                <div className="h-80 bg-muted animate-pulse rounded" />
                <div className="grid grid-cols-2 gap-2">
                  {[1, 2, 3, 4, 5, 6].map((i) => (
                    <div
                      key={i}
                      className="h-9 bg-muted animate-pulse rounded"
                    />
                  ))}
                </div>
                <div className="h-10 w-full bg-muted animate-pulse rounded" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
